/**
 * v0.4 追加要件⑫ 増分② (D-380): 恒常勤務パターンの「充足 (coverage)」と「融通枠 (flexSlots)」の
 * 定義。設計: docs/design/v04-standing-pattern-master-detail.md §4-1/§4-2。
 *
 * ⚠️ これはサーバー側 (apps/api/src/lib/standing-pattern-coverage.ts) のミラー実装。
 * 編集中 (未保存) のグリッドをサーバー往復なしでリアルタイム表示するための先行計算専用であり、
 * 保存・承認・監査ログに載る値は常にサーバー側の計算結果を使う。両実装は入力の正規化を必ず
 * 揃えること — weeklyContractedWorkDays は `== null` のみを「未設定」として扱い、`0`
 * (ゼロ日契約) は素通しする (§8-134 対策)。
 */

export type CoverageResult = { coverage: number | null; flexSlots: number | null };

export const computeStandingPatternCoverage = (
  entries: Array<{ dayOfWeek: number; preferenceLevelId: string }>,
  preferenceLevels: Map<string, { isAvailable: boolean; weight: number }>,
  weeklyContractedWorkDays: number | null,
): CoverageResult => {
  if (weeklyContractedWorkDays == null) return { coverage: null, flexSlots: null };

  const availableDays = new Set(
    entries
      .filter((e) => preferenceLevels.get(e.preferenceLevelId)?.isAvailable === true)
      .map((e) => e.dayOfWeek),
  );

  if (weeklyContractedWorkDays === 0) {
    return { coverage: 1, flexSlots: availableDays.size };
  }

  const coverage = Math.min(1, availableDays.size / weeklyContractedWorkDays);
  const flexSlots = Math.max(0, availableDays.size - weeklyContractedWorkDays);
  return { coverage, flexSlots };
};
